import { defineComponent, inject, createVNode } from "vue";
import { isNumber, isObject } from "../_utils/is.js";
import { getPrefixCls } from "../_utils/global-config.js";
var _GridCol = defineComponent({
  name: "Col",
  props: {
    span: {
      type: Number,
      default: 24
    },
    offset: {
      type: Number
    },
    order: {
      type: Number
    },
    xs: {
      type: [Number, Object]
    },
    sm: {
      type: [Number, Object]
    },
    md: {
      type: [Number, Object]
    },
    lg: {
      type: [Number, Object]
    },
    xl: {
      type: [Number, Object]
    },
    xxl: {
      type: [Number, Object]
    }
  },
  setup(props, {
    slots
  }) {
    const prefixCls = getPrefixCls("col");
    const rowContext = inject("rowContext");
    const adaptationGrid = (prefixCls2, mergeClassName) => {
      const {
        xs,
        sm,
        md,
        lg,
        xl,
        xxl
      } = props;
      const screenList = {
        xs,
        sm,
        md,
        lg,
        xl,
        xxl
      };
      Object.keys(screenList).forEach((screen) => {
        const screenValue = screenList[screen];
        if (screenValue && isNumber(screenValue)) {
          mergeClassName[`${prefixCls2}-${screen}-${screenValue}`] = true;
        } else if (screenValue && isObject(screenValue)) {
          mergeClassName[`${prefixCls2}-${screen}-${screenValue.span}`] = screenValue.span;
          mergeClassName[`${prefixCls2}-${screen}-offset-${screenValue.offset}`] = screenValue.offset;
          mergeClassName[`${prefixCls2}-${screen}-order-${screenValue.order}`] = screenValue.order;
        }
      });
      return mergeClassName;
    };
    return () => {
      var _a;
      const {
        span,
        offset,
        order,
        xs,
        sm,
        md,
        lg,
        xl,
        xxl
      } = props;
      const div = rowContext && rowContext.div;
      const gutter = rowContext && rowContext.gutter;
      const mergeClassName = {
        [`${prefixCls}`]: !div,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-${span}`]: !div && !xs && !sm && !md && !lg && !xl && !xxl,
        [`${prefixCls}-offset-${offset}`]: offset && offset > 0
      };
      const classNames = adaptationGrid(prefixCls, mergeClassName);
      const styles = {};
      if (Array.isArray(gutter) && !div) {
        const paddingHorizontal = gutter[0] && gutter[0] / 2 || 0;
        const paddingVertical = gutter[1] && gutter[1] / 2 || 0;
        if (paddingHorizontal) {
          styles.paddingLeft = `${paddingHorizontal}px`;
          styles.paddingRight = `${paddingHorizontal}px`;
        }
        if (paddingVertical) {
          styles.paddingTop = `${paddingVertical}px`;
          styles.paddingBottom = `${paddingVertical}px`;
        }
      }
      return createVNode("div", {
        "class": classNames,
        "style": styles
      }, [(_a = slots.default) == null ? void 0 : _a.call(slots)]);
    };
  }
});
export { _GridCol as default };
